import React, { useState, useEffect, useRef } from "react";

import "../../css/Banner.css";

import ImgBannerEn from "../../assets/image/Banner-EN.png";

export default function BannerEN(props) {
  return (
    <div className="banner-container">
      <img className="banner" src={ImgBannerEn}></img>
    </div>
  );
}
